import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import PeptidePrograms from './components/PeptidePrograms';
import WhyChooseUs from './components/WhyChooseUs';
import Results from './components/Results';
import LeadCapture from './components/LeadCapture';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SummerWelcomeModal from './components/SummerWelcomeModal';
import LandingPage from './components/LandingPage';
import BookingSystem from './components/BookingSystem';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentCancel from './components/PaymentCancel';
import MembershipPreview from './components/MembershipPreview';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import { captureAttributionFromURL, buildLeadPayload } from './utils/attribution';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [couponData, setCouponData] = useState(null);

  useEffect(() => {
    // Capture UTM / referrer on first page load and persist for the session.
    captureAttributionFromURL();

    // Summer popup is homepage-only. Suppress on non-homepage routes like
    // /membership-preview, /payment/success, /payment/cancel, /offer.
    const onHomepage =
      typeof window !== 'undefined' && window.location.pathname === '/';
    if (!onHomepage) return undefined;

    const hasSeenBefore = localStorage.getItem('snatchedBeautiesSummerModalSeen');
    if (!hasSeenBefore) {
      const timer = setTimeout(() => setShowModal(true), 5000);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
    setCouponData(null);
    localStorage.setItem('snatchedBeautiesSummerModalSeen', 'true');
  };

  const handleSubmitLead = async (fields, { source } = {}) => {
    setIsLoading(true);
    try {
      const payload = buildLeadPayload(
        {
          email: fields.email,
          name: fields.name || undefined,
        },
        { source }
      );
      const response = await axios.post(`${API}/leads`, payload);
      setCouponData(response.data);
      localStorage.setItem('snatchedBeautiesSummerModalSeen', 'true');
    } catch (error) {
      console.error('Error submitting lead:', error);
      setCouponData({ couponCode: 'PRIVE15', discount: '15%' });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="App bg-onyx min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/membership-preview" element={<MembershipPreview />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/offer" element={<LandingPage />} />
          <Route
            path="/"
            element={
              <>
                <Header />
                <Hero />
                <About />
                <Services />
                <PeptidePrograms />
                <LeadCapture
                  onSubmit={handleSubmitLead}
                  isLoading={isLoading}
                  couponData={couponData}
                />
                <WhyChooseUs />
                <Results />
                <BookingSystem />
                <Contact />
                <Footer />
              </>
            }
          />
        </Routes>
      </BrowserRouter>

      <SummerWelcomeModal
        isOpen={showModal}
        onClose={handleCloseModal}
        onSubmit={handleSubmitLead}
        isLoading={isLoading}
        couponData={couponData}
      />
    </div>
  );
}

export default App;
